import actionTypes from '../../action-types'

export default (toUserId) => ({
  type: actionTypes.USER.RELATION_DELETE_SUCCESS,
  payload: {
    toUserId,
  },
})
